import { useState } from "react";
import { faqs } from "@/mocks/trends";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-100/60">
      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-question-line"></i> FAQ
          </span>
          <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">吃瓜群众常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">关于榜单、可信度与平台原则，你想问的都在这里</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border bg-background-50 transition ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950 md:text-base">
                    <span className="font-heading text-primary-500">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </h3>
                  <i className={`ri-add-line text-xl transition-transform ${isOpen ? "rotate-45 text-primary-500" : "text-foreground-500"}`}></i>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <div className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}